import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";
import { SectionLayout } from "@/components/SectionLayout";
import { Heading, Text } from "@/components/Text";
import { Button } from "@/components/Button";
import { getCaseStudies } from "../../sanity/lib/getCmsData";
import { urlForImage } from "../../sanity/lib/image";

export async function getStaticProps() {
  const data = await getCaseStudies();
  return {
    props: {
      data,
    },
    revalidate: 10,
  };
}

export default function CaseStudies({ data }) {
  const heroBlockData = data.imageItemText;
  const caseStudiesBlockData = data.caseStudiesBlock;

  useEffect(() => {
    import("aos").then((AOS) => {
      import("aos/dist/aos.css");
      AOS.default.init({ duration: 500, easing: "ease-in", once: true, delay: 25 });
    });
  }, []);
  return (
    <>
      <Head>
        <title>Case Studies | Red Ball Drills</title>
        <meta
          name="description"
          content="Red Ball Drills have been used in hundreds of scenarios for a multitude of different industries."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Hero data={heroBlockData} />
      <Cases data={caseStudiesBlockData} />
    </>
  );
}

function Hero({ data }) {
  const { title, description, mainImage } = data;
  return (
    <SectionLayout>
      <article className="flex flex-col md:flex-row gap-12">
        <div className="md:flex-1">
          <Heading as="h1" size="page" className="mb-6" data-aos="fade-in">
            {title}
          </Heading>
          <Text className="mb-7">{description}</Text>
          <Button role="consultation" />
        </div>
        <div className="mx-auto md:mx-0 md:flex-1">
          <Image
            src={urlForImage(mainImage).url()}
            alt={mainImage.caption}
            width={516}
            height={432}
            priority={true}
          />
        </div>
      </article>
    </SectionLayout>
  );
}

function Cases({ data }) {
  const { caseStudies } = data;
  return (
    <SectionLayout>
      <div className="flex justify-center flex-wrap gap-6">
        {caseStudies.map((video, i) => (
          <CaseCard key={i} id={video?.tag?.id} videoLink={video.videoLink}>
            {video.title}
          </CaseCard>
        ))}
        {/* <article className="max-w-[530px] md:max-w-[570px] h-[70vw] min-[570px]:h-[405px] md:h-[500px] w-full flex flex-col justify-center items-center p-6 md:p-11 shadow-surround rounded-5xl bg-rbd-base">
          <Heading size="video-card">Coming Soon...</Heading>
        </article> */}
      </div>
    </SectionLayout>
  );
}

function CaseCard({ children, videoLink, ...props }) {
  return (
    <article
      className="max-w-[530px] md:max-w-[570px] md:h-[500px] w-full flex flex-col justify-between p-6 md:p-11 shadow-surround rounded-xl bg-rbd-base gap-4"
      {...props}
    >
      <Heading size="video-card">{children}</Heading>
      <div className="relative rounded-xl overflow-hidden aspect-[10/7] w-full">
        <iframe
          width="100%"
          height="100%"
          src={videoLink}
          title={children || "YouTube video player"}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </article>
  );
}
